/**
 * Keep key and name equal
 */
export enum FeatureFlag {
  // Permanent flags for development/testing purposes
  UseStagingApi = 'UseStagingApi',
  UseMiniprofiler = 'UseMiniprofiler',
  UseEnvironmentIndicator = 'UseEnvironmentIndicator',
  // Customer-facing toggle for multi-currency mode
  NoCurrency = 'NoCurrency',
  UseSageV2 = 'UseSageV2',
}

/**
 * Feature Hub flags, evaluated by the API for the active organisation.
 * Values must match the API's AssetAccountant.Contract.Configuration.FeatureFlags constants.
 */
export enum FeatureHubFlag {
  MultiStandardRegisters = 'REL_ENABLE_MULTI_STANDARD_REGISTERS_202610',
}

const featureHubFlagValues = new Set<string>(Object.values(FeatureHubFlag));

export function isFeatureHubFlag(flag: string): flag is FeatureHubFlag {
  return featureHubFlagValues.has(flag);
}

/**
 * Only use this where you can't inject the FeatureService
 */
export function featureIsEnabled(feature: FeatureFlag) {
  return !!localStorage.getItem(feature);
}
